import { ComboField } from '@components/Fields/ComboField';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { StringField } from '@components/Fields/StringField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IEnumCombo } from '@hooks/useCombo';
import { IFilter } from '@hooks/useFilter';
import { Divider, MenuItem } from '@material-ui/core';
import { EnumExcedenteStatus } from '@model/Excedente';
import { IExcedenteFilter } from '@services/ExcedenteService';
import React from 'react';

export type ExcedenteFilterProps = {
    filter: IFilter<IExcedenteFilter>
    isLoading: boolean
    excedenteStatusCombo: IEnumCombo<EnumExcedenteStatus>
}

export function ExcedenteFilter ({filter, isLoading, excedenteStatusCombo }: ExcedenteFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={1}>
                    <StringField
                        field={filter.fields.numero}
                        label="Número"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competencia}
                        label="Competência"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.excedenteStatus}
                        label="Status"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumExcedenteStatus.None}>Todos</MenuItem>
                        <Divider />
                        {
                            excedenteStatusCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>                
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}